import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import UserPublicationPin from "models/interfaces/user-publication-pin";
import PublicationRecord from "models/view-models/publication-record";

const defaultValues: UserPublicationPin =
    RecordUtils.auditableDefaultValuesFactory({
        userId: undefined,
        notebookId: undefined,
        publicationCode: "",
        publicationEdition: "",
        publication: undefined,
    });

export default class UserPublicationPinRecord
    extends Record(defaultValues)
    implements UserPublicationPin
{
    constructor(params?: UserPublicationPin) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.publication) {
            params.publication = RecordUtils.ensureRecord(
                params.publication,
                PublicationRecord
            );
        }

        super(params);
    }

    public with(values: Partial<UserPublicationPin>): UserPublicationPinRecord {
        return new UserPublicationPinRecord(
            Object.assign(this.toJS(), values) as UserPublicationPinRecord
        );
    }
}
